<template>
  <TableGradient
      icon-name="balance-scale"
      :title="$t('tuevs.scale.listagem.titulo_pagina')"
      :text-empty="$t('tuevs.scale.listagem.table.empty')"
      route-new="tuevs.scale.create"
      :text-new="$t('tuevs.scale.listagem.novo')"
      :fields="fields"
      :items="scales"
      :loading="isLoading"
      :paginator="pagination"
      @list="evt => $store.dispatch('tuevs/scale/listAll', evt)">
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.status, 'badge-danger': !linha.item.status}">
          <em v-if="linha.item.status">{{ $t('tuevs.scale.listagem.habilitado') }}</em>
          <em v-else>{{ $t('tuevs.scale.listagem.desabilitado') }}</em>
      </span>
    </template>
    <template v-slot:cell(id)="linha">
      <router-link :id="'link-edit-' + linha.index" :to="{ name: 'tuevs.scale.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('tuevs.scale.listagem.table.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      store_isLoading: 'tuevs/scale/isLoading',
      scales: 'tuevs/scale/all',
      pagination: 'tuevs/scale/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('tuevs.scale.listagem.table.nome'), sortable: true},
        {key: 'code', label: this.$t('tuevs.scale.listagem.table.codigo'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('tuevs.scale.listagem.table.editar')}
      ]
    }
  },
  methods: {
    ...mapActions([
      'tuevs/scale/listAll'
    ])
  },
  mounted() {
    this['tuevs/scale/listAll']()
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
